var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.error
        ? _c("b-notification", { attrs: { type: "is-danger" } }, [
            _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("b-field", { attrs: { grouped: "" } }, [
        _c("div", { staticClass: "field is-expanded" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Razón social")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.razon_social,
                  expression: "model.razon_social",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("razon social") },
              attrs: { disabled: !_vm.canEdit, name: "razon social" },
              domProps: { value: _vm.model.razon_social },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "razon_social", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.errors.has("razon social")
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("razon social"))),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Slug")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.slug,
                  expression: "model.slug",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, max: 20 },
                  expression: "{required:true,max:20}",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("slug") },
              attrs: { disabled: !_vm.canEdit, name: "slug" },
              domProps: { value: _vm.model.slug },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "slug", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.errors.has("slug")
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("slug"))),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("\n      CUIT\n    ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c("the-mask", {
              staticClass: "input",
              attrs: {
                disabled: !_vm.canEdit,
                mask: "##-########-#",
                type: "text",
                masked: false,
              },
              model: {
                value: _vm.model.cuit,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "cuit", $$v)
                },
                expression: "model.cuit",
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.cuit,
                  expression: "model.cuit",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("cuit") },
              attrs: { type: "hidden", name: "cuit" },
              domProps: { value: _vm.model.cuit },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "cuit", $event.target.value)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.errors.has("cuit")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("cuit"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("\n      Email\n    ")]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.email,
                expression: "model.email",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true, email: true },
                expression: "{required:true,email:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("email") },
            attrs: { type: "text", name: "email" },
            domProps: { value: _vm.model.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "email", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("email")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("email"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("\n      Teléfono\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.telefono,
                expression: "model.telefono",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("telefono") },
            attrs: { type: "text", name: "telefono" },
            domProps: { value: _vm.model.telefono },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "telefono", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("telefono")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("telefono"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("\n      Dirección\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.direccion,
                expression: "model.direccion",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("direccion") },
            attrs: { type: "text", name: "direccion" },
            domProps: { value: _vm.model.direccion },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.model, "direccion", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.errors.has("direccion")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("direccion"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "control is-clearfix" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary is-pulled-right",
            attrs: { disabled: _vm.errors.any() },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit()
              },
            },
          },
          [_c("i", { staticClass: "fas fa-save fa-fw" }), _vm._v(" Guardar")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }